export const settingsMessages = {
  PAGE: {
    TITLE: 'Settings',
    SUBTITLE: 'Click on a category to change the associated settings',
    NEW_USER_BUTTON: 'Add New User',
    TABLE_TITLE: 'User Details',
    TABLE_SUBTITLE: 'Details of all users in platform.',
    SOMETHING_WENT_WRONG:
      'Something went wrong. Try again after sometime or Please reachout to support team',
    NO_DATA_CONTENT: 'No Data Available',
    DELETE_SELECTED: 'Delete selected',
    DELETE_CONFIRMATION_TITLE:
      'Are you sure you want to delete this user account?',
    DELETE_CONFIRMATION_SUBTITLE:
      ' Once a user account is deleted it cannot be bought back',
    CONFIRM_DELETE: 'Confirm Delete',

    RESET_PASSWORD_CONFIRMATION_TITLE:
      'Are you sure you want to reset password for this user account?',
    CONFIRM_RESET_PASSWORD: 'Confirm Reset Password',
    TABS: ['User Details', 'Terms and Conditions'],
    USER_LOGS: 'User Logs',
    CLOSE: 'Close',
  },
  TABS: {
    USERMANAGEMENT: 'User Management',
    PROFILE: 'Profile',
    NOTIFICATIONS: 'Notifications',
    CREDENTIALS: 'Credentials',
  },
};
